import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../api/clients';
import { toast } from 'sonner';

export function useWholesale() {
  return useQuery({
    queryKey: ['wholesale'],
    queryFn: () => api.get('/wholesale').then(res => res.data),
    staleTime: 1000 * 60 * 2,
  });
}

export function useWholesaleItem(id: number) {
  return useQuery({
    queryKey: ['wholesale', id],
    queryFn: () => api.get(`/wholesale/${id}`).then(res => res.data),
    enabled: !!id && id > 0,
    staleTime: 1000 * 60 * 2,
  });
}

export function useCreateWholesale() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => api.post('/wholesale', data).then(res => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['wholesale'] });
      toast.success('Precio mayorista creado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al crear el precio mayorista');
    },
  });
}

export function useUpdateWholesale() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) =>
      api.put(`/wholesale/${id}`, data).then(res => res.data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['wholesale'] });
      queryClient.invalidateQueries({ queryKey: ['wholesale', id] });
      toast.success('Precio mayorista actualizado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al actualizar el precio mayorista');
    },
  });
}

export function useDeleteWholesale() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.delete(`/wholesale/${id}`).then(res => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['wholesale'] });
      toast.success('Precio mayorista eliminado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al eliminar el precio mayorista');
    },
  });
}